import axios from 'axios';

class FieldFileCore {

	constructor( section ) {
		this.section = section;
		if ( ! this.setVars() ) {
			return;
		}

		this.setEvents();
	}

	setVars() {
		this.items             = this.section.querySelectorAll( '.fpf-file-item' );
		this.file_inputs       = this.section.querySelectorAll( '.fpf-file-draggable-input' );
		this.value_inputs      = this.section.querySelectorAll( '.fpf-file-draggable-value' );
		this.filename_inputs   = this.section.querySelectorAll( '.fpf-file-draggable-filename' );
		this.error_texts       = this.section.querySelectorAll( '.fpf-file-draggable-error' );
		this.placeholder_texts = this.section.querySelectorAll( '.fpf-file-draggable-placeholder' );
		this.loading_texts     = this.section.querySelectorAll( '.fpf-file-draggable-loading' );
		this.filename_texts    = this.section.querySelectorAll( '.fpf-file-draggable-preview' );
		this.buttons_delete    = this.section.querySelectorAll( '.fpf-file-draggable-delete' );
		if ( ! this.items.length ) {
			return;
		}

		this.atts   = {
			item_index: 'data-index',
			section_api_url: 'data-api-url',
			section_api_error_code: 'data-api-error-code',
			section_api_error_message: 'data-api-error-message',
			section_field_name: 'data-field-name',
			section_group_id: 'data-group-id',
		};
		this.config = {
			api_url: this.section.getAttribute( this.atts.section_api_url ),
			api_error_code: this.section.getAttribute( this.atts.section_api_error_code ),
			api_error_message: this.section.getAttribute( this.atts.section_api_error_message ),
			field_name: this.section.getAttribute( this.atts.section_field_name ),
			group_id: this.section.getAttribute( this.atts.section_group_id ),
		};

		return true;
	}

	setEvents() {
		const { length } = this.items;
		for ( let i = 0; i < length; i++ ) {
			this.file_inputs[ i ].addEventListener( 'change', this.changeValue.bind( this, i, false ) );
			this.buttons_delete[ i ].addEventListener( 'click', this.changeValue.bind( this, i, true ) );
		}
	}

	changeValue( field_index, clear_value = false ) {
		const filename = ( this.file_inputs[ field_index ].files[ 0 ] )
			? this.file_inputs[ field_index ].files[ 0 ].name
			: null;

		this.error_texts[ field_index ].setAttribute( 'hidden', true );
		this.placeholder_texts[ field_index ].setAttribute( 'hidden', true );
		this.loading_texts[ field_index ].setAttribute( 'hidden', true );
		this.filename_texts[ field_index ].setAttribute( 'hidden', true );
		this.filename_texts[ field_index ].innerHTML = '';

		this.buttons_delete[ field_index ].setAttribute( 'hidden', true );

		this.value_inputs[ field_index ].value    = null;
		this.filename_inputs[ field_index ].value = null;

		if ( ( filename === null ) || ( clear_value === true ) ) {
			this.file_inputs[ field_index ].value = null;

			this.placeholder_texts[ field_index ].removeAttribute( 'hidden' );
			this.section.append( this.items[ field_index ] );

			this.sendChangeEvent( this.value_inputs[ field_index ] );
		} else {
			this.loading_texts[ field_index ].removeAttribute( 'hidden' );
			this.uploadFile( field_index );
		}

		setTimeout( () => {
			this.toggleItems();
		}, 0 );
	}

	uploadFile( field_index ) {
		const form_data = new FormData();
		const file_data = this.file_inputs[ field_index ].files[ 0 ];

		form_data.append( 'file', file_data );
		form_data.append( 'field_name', this.config.field_name );
		form_data.append( 'group_id', this.config.group_id );

		axios( {
			method: 'POST',
			url: this.config.api_url,
			data: form_data,
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		} )
			.then( ( response ) => {
				this.filename_texts[ field_index ].innerText = file_data.name;
				this.filename_inputs[ field_index ].value    = file_data.name;
				this.value_inputs[ field_index ].value       = response.data.file_id;

				this.loading_texts[ field_index ].setAttribute( 'hidden', true );
				this.filename_texts[ field_index ].removeAttribute( 'hidden' );
				this.buttons_delete[ field_index ].removeAttribute( 'hidden' );

				this.sendChangeEvent( this.value_inputs[ field_index ] );
			} )
			.catch( ( error ) => {
				this.error_texts[ field_index ].innerText = ( error.response.data.code === this.config.api_error_code )
					? error.response.data.message
					: this.config.api_error_message;

				this.loading_texts[ field_index ].setAttribute( 'hidden', true );
				this.error_texts[ field_index ].removeAttribute( 'hidden' );
				this.placeholder_texts[ field_index ].removeAttribute( 'hidden' );
			} );
	}

	sendChangeEvent( input ) {
		setTimeout( () => {
			input.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
		}, 0 );
	}

	toggleItems() {
		const items      = this.section.querySelectorAll( `[${ this.atts.item_index }]` );
		const show_index = ( this.getLatestFilledItem( items ) + 1 );

		const { length } = items;
		for ( let i = 0; i < length; i++ ) {
			if ( i <= show_index ) {
				items[ i ].removeAttribute( 'hidden' );
			} else {
				items[ i ].setAttribute( 'hidden', true );
			}
		}
	}

	getLatestFilledItem( items ) {
		const { length } = items;
		for ( let i = 0; i < length; i++ ) {
			const input_index = items[ i ].getAttribute( this.atts.item_index );
			if ( ( !! this.file_inputs[ input_index ].files[ 0 ] ) !== true ) {
				return ( i - 1 );
			}
		}
		return ( length - 1 );
	}
}

export default class FieldFile {

	constructor() {
		this.sections = document.querySelectorAll( '.fpf-file-items' );

		const { length } = this.sections;
		for ( let i = 0; i < length; i++ ) {
			new FieldFileCore( this.sections[ i ] );
		}
	}
}

